import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';


export default function useGetAllUsers() {

    const { data, error, mutate, isLoading } = useSWR(`${apiBaseURL}/api/users/All`, {
        //onSuccess: (data) => console.log('All users fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });

    const allUsers = data?.data?.map((x) => ({
        label: `${x.firstName} ${x.lastName}`,
        value: x.id
    }));

    return {
        allUsers,
        error,
        mutate,
        isLoading,
    }
}